import { createForm } from '../../../factories'

export default createForm(['notes'])


// WEBPACK FOOTER //
// ./src/store/modules/bioreq/forms/notes.js